import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { PermissionId } from 'utils/powerLevelsConfig';
import { getWorkspaceRolesSchema } from 'utils/yup/schemas/validationSchemas';

export type WorkspaceRolesFormType = {
  roleName: string;
  permissions: Record<PermissionId, boolean>;
};

const useWorkspaceRolesForm = () => {
  const { workspaceRoles } = useWorkspacesContext();

  const form = useForm<WorkspaceRolesFormType>({
    mode: 'all',
    resolver: yupResolver(getWorkspaceRolesSchema(workspaceRoles)),
    defaultValues: {
      roleName: '',
      permissions: {} as Record<PermissionId, boolean>,
    },
  });

  return form;
};

export default useWorkspaceRolesForm;
